<!-- <p>success-modal-with-check works!</p> -->
<div mat-dialog-content class="text-center" style="border-radius: 20px;">
    <button mat-icon-button (click)="onClose()" style="position: absolute; top: 8px; right: 8px;">
        <mat-icon>close</mat-icon>
    </button>
    <div style="font-size: 40px;"><svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78"
            fill="none">
            <path
                d="M39 68.25C45.7671 68.25 52.3249 65.9036 57.556 61.6106C62.7871 57.3175 66.3678 51.3435 67.688 44.7064C69.0082 38.0693 67.9862 31.1797 64.7962 25.2116C61.6062 19.2436 56.4455 14.5662 50.1935 11.9765C43.9415 9.38685 36.9849 9.0451 30.5092 11.0095C24.0334 12.9739 18.4391 17.1229 14.6795 22.7496C10.9199 28.3762 9.22755 35.1324 9.89085 41.867C10.5541 48.6015 13.532 54.8978 18.3171 59.6829"
                stroke="#2AA90B" stroke-width="5" stroke-linecap="round" />
            <path
                d="M52 32.5L37.152 50.3175C36.4965 51.1042 36.1687 51.4976 35.7281 51.5176C35.2875 51.5375 34.9255 51.1755 34.2014 50.4514L26 42.25"
                stroke="#2AA90B" stroke-width="5" stroke-linecap="round" />
        </svg></div>
    <h2>{{ translation.t('operatorSuccessModal','resolvedTitle') }}</h2>
    <p>{{ translation.t('operatorSuccessModal','resolvedText') }}</p>
</div>
